import React, { useCallback } from 'react';
import { Box, Grid, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import LoadingButton from './LoadingButton';

interface InlineAlertProps {
  buttonText?: string;
  hide?: boolean;
  isLoading?: boolean;
  message: string;
  onAccept?: Function;
  onClose?: Function;
  variant?: 'warning' | 'plain';
}

const InlineAlert: React.FC<InlineAlertProps> = React.memo(
  ({
    buttonText = 'OK',
    hide = false,
    isLoading = false,
    message = '',
    onAccept = null,
    onClose = null,
    variant = 'plain',
  }) => {
    const handleAccept = useCallback(
      (event: React.MouseEvent<HTMLButtonElement>) => {
        onAccept?.();
      },
      [],
    );

    const handleClose = useCallback(
      (event: React.MouseEvent<HTMLButtonElement>) => {
        onClose?.();
      },
      [],
    );

    if (hide) {
      return null;
    }

    return (
      <Box
        sx={{
          mt: 1,
          padding: 2,
          backgroundColor: 'warning.light',
        }}
      >
        <Grid container spacing={0}>
          <Grid container justifyContent="flex-start" size={1}>
            <WarningAmberIcon
              sx={{
                color: 'warning.dark',
              }}
              fontSize="large"
            />
          </Grid>
          <Grid size="grow">
            <Box sx={{ pl: 2 }}>{message}</Box>
          </Grid>
          <Grid container justifyContent="center" size={2}>
            <Box>
              <LoadingButton
                color="inherit"
                isLoading={isLoading}
                onClick={handleAccept}
                size="small"
                variant="text"
              >
                {buttonText}
              </LoadingButton>
            </Box>
          </Grid>
          <Grid justifyContent="flex-end" size={1}>
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={handleClose}
              sx={{
                borderRadius: '4px',
              }}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          </Grid>
        </Grid>
      </Box>
    );
  },
);

export default InlineAlert;
